/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_Visible_HeadingInputs */



/**
* | output |
* | --- |
* | "Decklists" |
*
* @param {Decks_Visible_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_visible_heading = /** @type {((inputs?: Decks_Visible_HeadingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Visible_HeadingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decklists")
	if (locale === "es") return /** @type {LocalizedString} */ ("Decklists")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Decklists")
	if (locale === "it") return /** @type {LocalizedString} */ ("Decklist")
	return /** @type {LocalizedString} */ ("Decklists")
});